import { GET_LEAGUES, GET_LEAGUE_CATEGORY } from '../actions/league';
const initialState = {
  leagueCategory: null,
  leagues: [],
};

export default function leagueReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LEAGUES:
      return {
        ...state,
        leagues: action.data,
      };
    case GET_LEAGUE_CATEGORY:
      return {
        ...state,
        leagueCategory: action.data,
      };
    default:
      return state;
  }
}
